module.exports = __webpack_public_path__ + "img/mastercard_old_payment_method_icon_142751.8372b944.svg";